import React from "react";

const ManageProducts = () => {
  return (
    <div>
      <h2 className="mt-4 text-center">Product Management is coming soon!</h2>
    </div>
  );
};

export default ManageProducts;
